"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DropdownContent_styled_exports = {};
__export(DropdownContent_styled_exports, {
  StyledCheckIcon: () => StyledCheckIcon,
  StyledDropdownContainer: () => StyledDropdownContainer,
  StyledDropdownContentWrapper: () => StyledDropdownContentWrapper,
  StyledHelperText: () => StyledHelperText,
  StyledIcon: () => StyledIcon,
  StyledItemIcon: () => StyledItemIcon,
  StyledItemTextContainer: () => StyledItemTextContainer,
  StyledListContainer: () => StyledListContainer,
  StyledMinorTitle: () => StyledMinorTitle,
  StyledNav: () => StyledNav,
  StyledOptionCheckBox: () => StyledOptionCheckBox,
  StyledOptionText: () => StyledOptionText,
  StyledPopover: () => StyledPopover
});
module.exports = __toCommonJS(DropdownContent_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_Popover = require("../../atoms/Popover/Popover.component");
var import_atoms = require("../../atoms");
var StyledDropdownContentWrapper = import_styled_components.default.div.withConfig({
  displayName: "DropdownContentstyled__StyledDropdownContentWrapper",
  componentId: "sc-b4sxcn-0"
})(["box-sizing:border-box;display:flex;flex-direction:column;"]);
var StyledPopover = (0, import_styled_components.default)(import_Popover.Popover).withConfig({
  displayName: "DropdownContentstyled__StyledPopover",
  componentId: "sc-b4sxcn-1"
})(function(_ref) {
  var width = _ref.width, maxHeight = _ref.maxHeight;
  return (0, import_styled_components.css)(["list-style-type:none;max-height:", ";overflow-y:auto;padding:0;min-width:144px;max-width:400px;width:", ";z-index:1;"], maxHeight, width);
});
var StyledListContainer = import_styled_components.default.ul.withConfig({
  displayName: "DropdownContentstyled__StyledListContainer",
  componentId: "sc-b4sxcn-2"
})(["list-style-type:none;padding:0;"]);
var StyledDropdownContainer = import_styled_components.default.div.withConfig({
  displayName: "DropdownContentstyled__StyledDropdownContainer",
  componentId: "sc-b4sxcn-3"
})(["padding:0;margin:0;"]);
var StyledHelperText = import_styled_components.default.div.withConfig({
  displayName: "DropdownContentstyled__StyledHelperText",
  componentId: "sc-b4sxcn-4"
})(function(_ref2) {
  var theme = _ref2.theme, width = _ref2.width, errorMode = _ref2.errorMode, darkMode = _ref2.darkMode;
  return (0, import_styled_components.css)(["font-size:", ";font-family:", ";color:", ";", " line-height:20px;margin-left:", ";max-width:", ";display:-webkit-box;overflow:hidden;-webkit-line-clamp:2;-webkit-box-orient:vertical;"], theme.typography.sizes.small, theme.typography.fonts.primary, errorMode ? theme.colors.status.error["100"] : theme.colors.beige["180"], darkMode && "\n        color: ".concat(errorMode ? theme.colors.status.error["20"] : theme.colors.white, ";\n    "), errorMode ? "0" : "5px", width);
});
var StyledIcon = (0, import_styled_components.default)(import_atoms.Icon).withConfig({
  displayName: "DropdownContentstyled__StyledIcon",
  componentId: "sc-b4sxcn-5"
})(function(_ref3) {
  var theme = _ref3.theme;
  return (0, import_styled_components.css)(["font-size:17px;line-height:24px;margin-right:", ";"], theme.measurements.small);
});
var StyledItemTextContainer = import_styled_components.default.div.withConfig({
  displayName: "DropdownContentstyled__StyledItemTextContainer",
  componentId: "sc-b4sxcn-6"
})(function(_ref4) {
  var theme = _ref4.theme;
  return (0, import_styled_components.css)(["display:flex;flex-direction:column;flex-grow:1;font-family:", ";font-weight:", ";text-align:left;width:calc(100% - 52px);max-width:100%;margin-left:", ";"], theme.typography.fonts.primary, theme.typography.weights.regular, theme.measurements.medium);
});
var StyledMinorTitle = import_styled_components.default.span.withConfig({
  displayName: "DropdownContentstyled__StyledMinorTitle",
  componentId: "sc-b4sxcn-7"
})(function(_ref5) {
  var theme = _ref5.theme;
  return (0, import_styled_components.css)(["font-size:", ";line-height:", ";text-transform:uppercase;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;letter-spacing:", ";"], theme.typography.sizes.extraSmall, theme.measurements.extraLarge, theme.measurements.extraExtraSmall);
});
var StyledOptionText = import_styled_components.default.span.withConfig({
  displayName: "DropdownContentstyled__StyledOptionText",
  componentId: "sc-b4sxcn-8"
})(function(_ref6) {
  var theme = _ref6.theme, optionsOverflow = _ref6.optionsOverflow;
  return (0, import_styled_components.css)(["font-size:", ";line-height:24px;overflow:hidden;", " white-space:", ";", " max-width:100%;"], theme.typography.sizes.medium, optionsOverflow === "ellipsis" && "text-overflow: ellipsis;", optionsOverflow === "ellipsis" ? "nowrap" : "normal", optionsOverflow === "word-wrap" && "word-wrap: break-word;");
});
var StyledItemIcon = (0, import_styled_components.default)(import_atoms.Icon).withConfig({
  displayName: "DropdownContentstyled__StyledItemIcon",
  componentId: "sc-b4sxcn-9"
})(function() {
  return (0, import_styled_components.css)(["color:inherit;font-size:20px;padding:6px;"]);
});
var StyledCheckIcon = (0, import_styled_components.default)(import_atoms.Icon).withConfig({
  displayName: "DropdownContentstyled__StyledCheckIcon",
  componentId: "sc-b4sxcn-10"
})(function(_ref7) {
  var theme = _ref7.theme;
  return (0, import_styled_components.css)(["color:", ";font-size:", ";"], theme.colors.pr.base, theme.measurements.extraExtraLarge);
});
var StyledOptionCheckBox = (0, import_styled_components.default)(import_atoms.Checkbox).withConfig({
  displayName: "DropdownContentstyled__StyledOptionCheckBox",
  componentId: "sc-b4sxcn-11"
})(["box-sizing:border-box;width:24px;height:24px;span{box-sizing:border-box;}margin-right:16px;"]);
var StyledNav = import_styled_components.default.nav.withConfig({
  displayName: "DropdownContentstyled__StyledNav",
  componentId: "sc-b4sxcn-12"
})([""]);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledCheckIcon,
  StyledDropdownContainer,
  StyledDropdownContentWrapper,
  StyledHelperText,
  StyledIcon,
  StyledItemIcon,
  StyledItemTextContainer,
  StyledListContainer,
  StyledMinorTitle,
  StyledNav,
  StyledOptionCheckBox,
  StyledOptionText,
  StyledPopover
});
//# sourceMappingURL=DropdownContent.styled.js.map